// src/locale/en.js
import en from 'vuetify/es5/locale/en';


export default {
	label: 'English',
	//page login
	login: 'Login',
	logout: 'Logout',
	register: 'Register',
	username: 'Username',
	password: 'Password',
	login_account: 'Login accoount',
	// menu
	home_tabs: {
		home: 'Home',
		plan: 'Plan',
		task: 'Task',
		consuling: 'Consuling',
		calendar: 'Calendar',
		report: 'Report',
		meeting: 'Meeting',
		notice: 'Notice',
		coach: 'coach',
		customer: 'customer',
	},
	msg: 'Item Text',
	//
	...en,
}